import { gql } from "@apollo/client";

const CANCEL_NOMINATION = gql`
mutation CancelNomination($id: String){
    cancelNomination(id: $id)
    }
`;

export default CANCEL_NOMINATION;
